<script>
    import { Swipe, SwipeItem } from "svelte-swipe";
    import Source from '../common/PictureSource.svelte';

    let active_item = 0; //readonly
    let SwipeComp;
  
    function changeSlide(i){
      SwipeComp.goTo(i)
    }
  
    export let images = [];

</script>

<style>
  .card, .thumb img {border-radius: .5rem;}
  .swipe-holder{
    width: 100%;
    height: 90vw;
  }
  .card-footer{
    justify-content: center;
    align-items: center;
  }
  .thumb img {
    height:60px; 
    width:60px; 
    cursor:pointer;
    object-fit: cover;
    object-position: center;
    margin: .1rem;
  }
  img.featured {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    padding: .5rem;
  }
  img.featured, .card {
    background-color: rgb(43 43 43);
  }
  .card-footer {
    background-color: rgb(65, 64, 64);
    border-top: gray;
    padding: .1rem;
  }
  .active img { 
    border: solid 1px white
  }
  @media(min-width:769px){ 
    .swipe-holder{
      height: 30vw;
  }

  }
  
</style>

<div class="card">
  <div class="swipe-holder card-image">
      <Swipe bind:active_item bind:this={SwipeComp}>
          {#each images as image}
          <SwipeItem>
            <picture>
              <Source media="(max-width: 600px)" fit="max" width=500 height=525 {image} /> 
              <Source media="(min-width: 601px)" fit="max" width=665 height=676 {image} /> 
              <Source media="(min-width: 769px)" fit="max" width=415 height=365 {image} /> 
              <Source media="(min-width: 1230px)" fit="max" width=665 height=676 {image} /> 
              <img class="featured" src="{image}?fit=max&w=500&h=525&fm=jpg">
            </picture>
          </SwipeItem>
          {/each}
      </Swipe>
  </div>
  <div class="card-footer">
    {#each images as image, i}
      <picture class="{active_item == i ? 'active' : ''} thumb" on:click={() => changeSlide(i)} >
        <Source fit="crop" width=60 height=60 {image} /> 
        <img class="image" src="{image}?fit=crop&w=60&h=60fm=jpg" alt="Thumb {i}">
      </picture>

    {/each}
  </div>
</div>

